import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { StatusType } from '@uigy/generated/graphql';
import { filter, map, switchMap } from 'rxjs/operators';
import { StatusDataService } from '@uigy/shared/services/statusData.service';
import { AppInitializationService } from '@uigy/shared/services/app-initialization.service';

export const EnableGuard: CanActivateFn | CanMatchFn = () => {
  const statusDataService: StatusDataService = inject(StatusDataService);
  const appInitializationService: AppInitializationService = inject(AppInitializationService);

  return appInitializationService.appInitialized.pipe(
    filter(isInitialized => isInitialized),
    switchMap(() => statusDataService.getStatus().pipe(
      map((status: StatusType | null) => status === StatusType.Enabled),
    ))
  );
};
